import React from 'react';
import Markup from './markup/Markup';

// CSS & SASS
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/scss/style.scss';

// JS
import 'bootstrap/dist/js/bootstrap.min.js';
import { createTheme, ThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import "@fontsource/montserrat"; 

// 1. IMPORT HELMET PROVIDER
import { HelmetProvider } from 'react-helmet-async';

const theme = createTheme({
  typography: {
    fontFamily: 'Montserrat',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'Montserrat';
          font-style: normal;
          font-display: swap;
          font-weight: 400;
          src: local('Montserrat'), url('https://fonts.gstatic.com/s/montserrat/v15/JTUSjIg1_i6t8kCHKm459Wlhzg.ttf') format('truetype');
          unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        }
      `,
    },
  },
});

const App = () => {
  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Markup />
      </ThemeProvider>
    </HelmetProvider>
  );
};

export default App;